import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '@env/environment';
import { VendorMeApiResponse, VendorMeDto } from '../models/dashboard.models';
import { ConfirmResetPasswordPayload, ConfirmResetPasswordResponse } from '../models/vendor-profile.models';

@Injectable({
  providedIn: 'root',
})
export class VendorProfileService {
  private baseAPI = environment.baseAPI;
  private profile$?: Observable<VendorMeDto | null>;

  constructor(private http: HttpClient) {}

  getProfile(): Observable<VendorMeDto | null> {
    if (!this.profile$) {
      this.profile$ = this.http
        .get<VendorMeApiResponse>(`${this.baseAPI}/vendor/dashboard/me`)
        .pipe(
          map((response) => response?.data ?? null),
          catchError(() => of(null)),
          shareReplay(1),
        );
    }
    return this.profile$;
  }

  clear(): void {
    this.profile$ = undefined;
  }

  /** Clear cache and fetch a fresh profile from the API. */
  refreshProfile(): Observable<VendorMeDto | null> {
    this.clear();
    return this.getProfile();
  }

  confirmResetPassword(
    payload: ConfirmResetPasswordPayload,
  ): Observable<ConfirmResetPasswordResponse> {
    return this.http.post<ConfirmResetPasswordResponse>(
      `${this.baseAPI}/Authentication/change-password/confirm`,
      payload,
    );
  }
}
